import { Breadcrumbs as MUIBreadcrumbs } from "@mui/material";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams } from "react-router-dom";
import AppStore, { BreadcrumbsDI } from "../stores/AppStore";
import style from "./breadcrumbs.module.css";

interface BreadCrumbsProps {
  links: Array<BreadcrumbsDI>;
  withImage?: Boolean;
}

const Breadcrumbs: React.FunctionComponent<BreadCrumbsProps> = (
  props: BreadCrumbsProps
) => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const isLessonRoute = useMemo(() => {
    return (
      Object.keys(params).length === 0 &&
      location.pathname.localeCompare(AppStore.lessonsRoute) === 0
    );
  }, [location.pathname]);

  return (
    <div className={`breadcrumbs ${!props.withImage ? style.breadcrumbs_container : ''}`}>
      {props.links.length > 0 && (
        <div className={`${style.listWrap} ${style.breadCrumbsWrap}`}>
          <MUIBreadcrumbs
            separator={
              isLessonRoute ? (
                <span className={style.sep_above_image}>{"›"}</span>
              ) : (
                "›"
              )
            }
            aria-label="breadcrumb"
          >
            {props.links.map((link, i) => {
              let sliceIndex = link.name.lastIndexOf(":");
              if (sliceIndex != -1) {
                link.name = link.name.slice(sliceIndex);
              }
              return !link.isLast ? (
                <Link
                  key={i + link.name}
                  tabIndex={0}
                  aria-label={t(link.name)}
                  to={link.route || ""}
                  className={`${style.breadcrumbs_link} ${
                    isLessonRoute ? style.above_image : ""
                  }`}
                >
                  {t(link.name)}
                </Link>
              ) : (
                <span
                  key={i + link.name}
                  className={`${style.breadcrumbs_unlinkeds} ${
                    isLessonRoute ? style.above_image : ""
                  }`}
                  tabIndex={0}
                  aria-label={t(link.name)}
                >
                  {t(link.name)}
                </span>
              );
            })}
          </MUIBreadcrumbs>
        </div>
      )}
    </div>
  );
};

export default Breadcrumbs;
